import { thunk } from "redux-thunk";
import rootReducer from "./reducers";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: rootReducer,
  Middleware: [thunk],
});

export let _store = store;

export default store;
